import React from 'react'
import { authRoles } from '../../auth/authRoles'

const catalogListRoutes = [
    {
        path: '/catalog',
        component: React.lazy(() => import('./Catalog')),
        auth: authRoles.sa,
        accessPageName: 'CATALOG',
    },
    {
        path: '/category/([0-9]+)',
        component: React.lazy(() => import('./Catalog')),
        auth: authRoles.sa,
        accessPageName: 'CATALOG',
    },
    // {
    //     path: '/catalog/category/([0-9]+)',
    //     component: React.lazy(() => import('./Catalog')),
    //     auth: authRoles.sa,
    // },
    // {
    //     path: '/order/newOrderFastFood',
    //     component: React.lazy(() => import('./OrderFastFood/NewOrder')),
    //     auth: authRoles.admin,
    // },
    // {
    //     path: '/order/allOrder',
    //     component: React.lazy(() => import('./AllOrder')),
    //     auth: authRoles.sa,
    // },
    // {
    //     path: '/order/editOrder',
    //     component: React.lazy(() => import('./EditOrder')),
    //     auth: authRoles.admin,
    // },
    // {
    //     path: '/order/newOrderFast',
    //     component: React.lazy(() => import('./NewOrderFast')),
    //     auth: authRoles.admin,
    // },
]

export default catalogListRoutes
